export default "__VITE_PUBLIC_ASSET__5358b882__"